import React, { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { OutletContextParams } from './delivery-orders-screen';
import { TransportationsTabInfiniteScroll } from './transportations-tab-infinite-scroll';
import { TransportationsTabDefault } from './transportations-tab-default';

type TransportationsTabProps = {
  type?: 'standalone' | 'combined';
  status: 'created' | 'sent' | 'received';
};

export const TransportationsTab = (props: TransportationsTabProps) => {
  const { selectedLocalMethods } = useOutletContext<OutletContextParams>();

  return (
    <>
      {selectedLocalMethods.length ? (
        <TransportationsTabInfiniteScroll status={props.status} />
      ) : (
        <TransportationsTabDefault status={props.status} />
      )}
    </>
  );
};
